export const REQUEST = 'Admin/SurveyTemplates/REQUEST';
export const SUCCESS = 'Admin/SurveyTemplates/SUCCESS';
export const ERROR = 'Admin/SurveyTemplates/ERROR';

export const SET = 'Admin/SurveyTemplates/SET';
export const DELETED = 'Admin/SurveyTemplates/DELETED';
export const ADDED = 'Admin/SurveyTemplates/ADDED';
